<mat-card class="toggle-filter" [class]="{ 'toggle-filter--not-standalone': !standalone() }" (click)="onToggleChange()">
  @if (icon(); as icon) {
    <mat-icon class="toggle-filter__icon material-icons-outlined" [mpIcon]="icon" />
  }

  <div class="toggle-filter__filter-name truncate" [title]="filterName()">
    {{ filterName() }}
  </div>

  <div class="toggle-wrapper">
    @if (showLabels() && (inactiveLabel() | number); as inactiveLabel) {
      <span class="toggle-wrapper__label truncate" [title]="inactiveLabel">{{ inactiveLabel }}</span>
    }

    <mat-slide-toggle
      [checked]="checked()"
      hideIcon
      (change)="onToggleChange($event.checked)"
      (click)="$event.stopPropagation()"
    />

    @if (showLabels() && (activeLabel() | number); as activeLabel) {
      <span class="toggle-wrapper__label truncate" [title]="activeLabel">{{ activeLabel }}</span>
    }
  </div>
</mat-card>
